import React, { useState, useRef } from "react";  // ← add useRef
import axios from "axios";
import { FaUser } from "react-icons/fa";
import "../Styling/Amazon_ExcelUploadScreen.css";
import { Base_URL } from "../url";

const MONTHS = [
  "January", "February", "March", "April",
  "May", "June", "July", "August",
  "September", "October", "November", "December",
];

const currentYear = new Date().getFullYear();
const currentMonthName = MONTHS[new Date().getMonth()];
const YEARS = Array.from({ length: 7 }, (_, i) => currentYear - 6 + i);

const Amazon_ExcelUploadScreen = () => {
  const [file, setFile] = useState(null);
  const [year, setYear] = useState(String(currentYear));
  const [month, setMonth] = useState(currentMonthName);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });
  const fileInputRef = useRef(null);   // ← ref to directly reset the input

  const extractErrorMessage = (error) => {
    if (typeof error === "string") {
      if (error.includes("Database error")) return "Database error occurred during upload.";
      if (error.includes("Invalid data format")) return "Invalid data format inside file.";
      return error.split("\n")[0];
    }
    return "Upload failed.";
  };

  const resetForm = () => {
    setFile(null);
    if (fileInputRef.current) fileInputRef.current.value = ""; // ← clears the DOM input
  };

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    setFile(selected || null);
    setMessage({ type: "", text: "" });
  };

  const handleUpload = async () => {
    if (!file) {
      setMessage({ type: "error", text: "Please select a file." });
      return;
    }
    if (!year || !month) {
      setMessage({ type: "error", text: "Please select both year and month." });
      return;
    }

    setLoading(true);
    setMessage({ type: "info", text: "Reading file..." });

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("year", year);
      formData.append("month", month);

      const response = await axios.post(
        `${Base_URL}/Amazon_Screen_Request/upload/v2`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      setMessage({
        type: "success",
        text: `Upload successful. Total Records: ${response.data.totalRecords}`,
      });
      resetForm(); // ← resets both state AND the DOM input
    } catch (err) {
      let errorMessage = "Upload failed.";
      if (err.response?.data) {
        errorMessage = extractErrorMessage(err.response.data);
      } else if (err.message) {
        errorMessage = err.message;
      }
      setMessage({ type: "error", text: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  const isDisabled = loading || !file || !year || !month;

  return (
    <div className="amz-eu-page">
      <div className="amz-eu-card">

        {/* ── HEADER ── */}
        <div className="amz-eu-header">
          <div className="amz-eu-icon"><FaUser /></div>
          <h2 className="amz-eu-title">Amazon Excel / CSV Upload</h2>
        </div>

        {/* ── YEAR DROPDOWN ── */}
        <div className="amz-eu-field">
          <label className="amz-eu-label">Year</label>
          <select
            value={year}
            onChange={(e) => setYear(e.target.value)}
            disabled={loading}
            className="amz-eu-select"
          >
            {YEARS.map((y) => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>

        {/* ── MONTH DROPDOWN ── */}
        <div className="amz-eu-field">
          <label className="amz-eu-label">Month</label>
          <select
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            disabled={loading}
            className="amz-eu-select"
          >
            {MONTHS.map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>

        {/* ── FILE INPUT ── */}
        <div className="amz-eu-field">
          <label className="amz-eu-label">Excel / CSV File</label>
          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            disabled={loading}
            className="amz-eu-file-input"
            ref={fileInputRef}   // ← attach ref
          />
        </div>

        {/* ── UPLOAD BUTTON ── */}
        <button
          onClick={handleUpload}
          disabled={isDisabled}
          className="amz-eu-btn"
        >
          {loading ? (
            <><span className="amz-eu-spinner" />Processing...</>
          ) : (
            "Upload Excel"
          )}
        </button>

        {/* ── ALERT MESSAGE ── */}
        {message.text && (
          <div className={`amz-eu-alert amz-eu-alert--${message.type}`}>
            {message.text}
          </div>
        )}

      </div>
    </div>
  );
};

export default Amazon_ExcelUploadScreen;
// csv working code 
// import React, { useState } from "react";
// import axios from "axios";
// import * as XLSX from "xlsx";
// import "../Styling/MahExcelUploadScreen.css";

// const MahExcelUploadScreen = () => {
//   const [year, setYear] = useState(new Date().getFullYear().toString());
//   const [month, setMonth] = useState("January");
//   const [file, setFile] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState({ type: "", text: "" });

//   const months = [
//     "All Months",
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December"
//   ];

//   const years = ["2025", "2026"];

//   const handleUpload = async (e) => {
//     e.preventDefault();

//     if (!file) {
//       setMessage({ type: "error", text: "Please select an Excel or CSV file." });
//       return;
//     }

//     const isCsv = file.name.toLowerCase().endsWith(".csv");

//     setLoading(true);
//     setMessage({ type: "info", text: "Reading file..." });

//     const reader = new FileReader();

//     reader.onload = async (evt) => {
//       try {
//         const data = evt.target.result;

//         // 🔹 Read Excel or CSV
//         const workbook = XLSX.read(data, {
//           type: isCsv ? "string" : "binary",
//           cellDates: true
//         });

//         const worksheet = workbook.Sheets[workbook.SheetNames[0]];
//         const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: true });

//         let finalData = jsonData;

//         // 🔹 Month & Year filtering
//         if (month !== "All Months") {
//           const selectedMonthIndex = months.indexOf(month) - 1;
//           const selectedYear = parseInt(year, 10);

//           finalData = jsonData.filter((row) => {
//             const dateKey = Object.keys(row).find(
//               (k) => k.trim().toLowerCase() === "shipment date"
//             );

//             if (!dateKey || !row[dateKey]) return false;

//             let shipmentDate = row[dateKey];

//             // Excel serial date
//             if (typeof shipmentDate === "number") {
//               const parsed = XLSX.SSF.parse_date_code(shipmentDate);
//               shipmentDate = new Date(
//                 parsed.y,
//                 parsed.m - 1,
//                 parsed.d,
//                 parsed.H,
//                 parsed.M,
//                 parsed.S
//               );
//             }

//             if (!(shipmentDate instanceof Date)) {
//               shipmentDate = new Date(shipmentDate);
//             }

//             if (isNaN(shipmentDate.getTime())) return false;

//             return (
//               shipmentDate.getMonth() === selectedMonthIndex &&
//               shipmentDate.getFullYear() === selectedYear
//             );
//           });

//           if (!finalData.length) {
//             throw new Error(`No records found for ${month} ${year}`);
//           }
//         }

//         setMessage({
//           type: "info",
//           text: "Filtering complete. Creating Excel..."
//         });

//         // 🔹 Convert filtered data → Excel
//         const newSheet = XLSX.utils.json_to_sheet(finalData);
//         const newWorkbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(newWorkbook, newSheet, "Data");

//         const buffer = XLSX.write(newWorkbook, {
//           bookType: "xlsx",
//           type: "array"
//         });

//         const excelBlob = new Blob([buffer], {
//           type:
//             "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
//         });

//         // 🔹 Prepare form data
//         const formData = new FormData();
//         formData.append("year", year);
//         formData.append("month", month);
//         formData.append(
//           "file",
//           excelBlob,
//           `Uploaded_${isCsv ? "CSV" : "Excel"}_${month}_${year}.xlsx`
//         );
//         console.log(formData);

//         // 🔹 Upload
//         // const response = await axios.post(
//         //   "http://192.168.29.242:5032/api/Amazon_MTR/upload",
//         //   formData,
//         //   { headers: { "Content-Type": "multipart/form-data" } }
//         // );

//         const response = await axios.post(
//           "http://localhost:5090/api/Amazon_MTR/upload",
//           formData,
//           { headers: { "Content-Type": "multipart/form-data" } }
//         )


//         setMessage({
//           type: "success",
//           text:
//             response.data?.message ||
//             `Uploaded ${finalData.length} records successfully`
//         });

//         setFile(null);
//         e.target.reset();
//       } catch (err) {
//         console.error(err);

//         let errorMessage = "Upload failed";

//         if (err.response?.data) {
//           errorMessage =
//             err.response.data.message ||
//             err.response.data.error ||
//             JSON.stringify(err.response.data);
//         } else if (err.message) {
//           errorMessage = err.message;
//         }

//         setMessage({ type: "error", text: errorMessage });
//       } finally {
//         setLoading(false);
//       }
//     };

//     // 🔹 Read correctly based on file type
//     if (isCsv) {
//       reader.readAsText(file);
//     } else {
//       reader.readAsBinaryString(file);
//     }
//   };

//   return (
//     <div className="upload-container">
//       <div className="upload-card">
//         <h2 className="upload-title">Amazon Excel / CSV Upload</h2>
//         <p className="upload-subtitle">
//           Filters by Shipment Date and uploads as Excel
//         </p>

//         <form onSubmit={handleUpload} className="upload-form">
//           <div className="input-group">
//             <label>Select Year</label>
//             <select value={year} onChange={(e) => setYear(e.target.value)}>
//               {years.map((y) => (
//                 <option key={y}>{y}</option>
//               ))}
//             </select>
//           </div>

//           <div className="input-group">
//             <label>Select Month</label>
//             <select value={month} onChange={(e) => setMonth(e.target.value)}>
//               {months.map((m) => (
//                 <option key={m}>{m}</option>
//               ))}
//             </select>
//           </div>

//           <div className="input-group">
//             <label>Excel / CSV File</label>
//             <input
//               type="file"
//               accept=".xlsx,.xls,.csv"
//               onChange={(e) => setFile(e.target.files[0])}
//               disabled={loading}
//             />
//           </div>

//           <button disabled={loading}>
//             {loading ? "Processing..." : "Filter & Upload"}
//           </button>
//         </form>

//         {message.text && (
//           <div className={`alert ${message.type}`}>{message.text}</div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MahExcelUploadScreen;

